import { Button, Grid, Pagination, Typography } from "@mui/material";
import { Fragment } from "react";
import SelectBox from "../../../components/SelectBox";
import { getPreview } from "../../../http/api/ReportSaveAPI";
import HistoryTableBody from "./HistoryTableBody";

const HistoryTable = (props) => {
  const { reports, paging, reportTypes, printPreview } = props;
  async function handleClickPreview() {
    const listSavePath = reports.Value.filter(
      (report) => report.isChecked === true
    ).map((report) => report.savePath);

    if (listSavePath == []) return;
    let response = await getPreview({ listSavePath });
    const blob = new Blob([response], {
      type: "application/pdf",
      encoding: "UTF-8",
    });
    const fileUrl = URL.createObjectURL(blob);
    printPreview.updates({ open: true, url: fileUrl });
  }
  return (
    <Fragment>
      <Grid container display="flex" justifyContent="space-between" my={3}>
        <Grid item xs={2} display="flex">
          <Button
            variant="contained"
            onClick={handleClickPreview}
            disabled={!reports.Value.some((obj) => obj.isChecked === true)}
          >
            プレビュー
          </Button>
        </Grid>
        <Grid item xs={2} display="flex" justifyContent="flex-end">
          <Typography fontWeight="bold" fontSize={20}>
            検索一覧
            {reports.Value.length > 0
              ? `（件数：${reports.Value.length}）`
              : ""}
          </Typography>
        </Grid>
      </Grid>
      <HistoryTableBody
        reports={reports}
        paging={paging}
        reportTypes={reportTypes}
      ></HistoryTableBody>
      {/* Pagination */}
      <Grid container display="flex" justifyContent="space-between" mt={5}>
        <Grid item xs={2}>
          <SelectBox
            data={[10, 25, 50].map((x) => {
              return {
                key: x,
                value: x,
              };
            })}
            onChange={(e) => {
              paging.update("itemsPerPage", e.target.value);
              paging.update("page", 1);
            }}
            value={paging.Value.itemsPerPage}
            sx={{ width: 100 }}
            label={"表示件数　"}
            nullable={false}
          />
        </Grid>
        <Grid item xs={8} display="flex" justifyContent="center">
          <Pagination
            count={
              Math.floor(
                (reports.Value.length - 1) / paging.Value.itemsPerPage
              ) + 1
            }
            page={paging.Value.page}
            onChange={(e, newPage) => {
              paging.update("page", newPage);
            }}
            variant="outlined"
            shape="rounded"
          />
        </Grid>
        <Grid item xs={2}></Grid>
      </Grid>
    </Fragment>
  );
};
export default HistoryTable;
